export const company = {
  name: 'MAYAN Technology',
  shortName: 'MAYAN',
  foundedYear: 2006,
  tagline: 'Engineering, consultation, and technology solutions from concept through completion.',
  grade: 'Grade A E/M and Civil Works',
  about: [
    'MAYAN Technology is a Jordanian establishment, founded in 2006, specialised in engineering services, economic and industrial research, consultation, feasibility studies in both macro and micro economics, industrial equipment and materials supply, and IT and telecom solutions.',
    'Our aim is to provide clients with the latest technologies and global professional engineering and consultation solutions for all types of industries, from concept planning through project completion.',
    'Large-scope engineering projects are conducted jointly with associated world-leading engineering and consultation firms. Smaller projects are engineered in-house.',
    'Various types of inspection, studies, and consulting services can be offered.',
  ],
  mission:
    'To understand and accomplish our clients’ needs by providing limitless service and support, and to make sure that the solutions offered are cost-effective and meet customer satisfaction.',
  vision:
    'To be the best solutions provider by facilitating new applications, professional services, and after-sales services.',
  electromechanical: {
    title: 'Electromechanical (E/M) & Civil Works',
    description:
      'We have excellent experience in E/M and civil works. Our company (Grade A E/M and Civil Works) has implemented many successful projects.',
    items: [
      'Fire fighting systems',
      'Air conditioning',
      'Pumps and compressors installation, including piping',
      'Transformers and gear switches installation and commissioning',
      'E/M for buildings and premises',
      'Control panels, PLC and SCADA systems, automation, and electronic control',
    ],
  },
  highlights: [
    { value: '2006', label: 'Established in Jordan' },
    { value: 'Grade A', label: 'E/M & Civil Works' },
    { value: '8', label: 'Service sectors' },
    { value: '4', label: 'Solution lines' },
  ],
};
